import img1 from "../assets/gallery/image1.jpeg";
import img2 from "../assets/gallery/image2.jpeg";
import img3 from "../assets/gallery/image3.jpeg";
import img4 from "../assets/gallery/image4.jpeg";
import img5 from "../assets/gallery/image5.jpeg";
import img6 from "../assets/gallery/image6.jpeg";
import img7 from "../assets/gallery/image7.jpeg";
import img8 from "../assets/gallery/image8.jpeg";
import img9 from "../assets/gallery/image9.jpeg";
import img10 from "../assets/gallery/image10.jpeg";
import img11 from "../assets/gallery/image11.jpeg";
import img12 from "../assets/gallery/image12.jpeg";
import img13 from "../assets/gallery/image13.jpeg";
import img14 from "../assets/gallery/image14.jpeg";
import img15 from "../assets/gallery/image15.jpeg";
import img16 from "../assets/gallery/image16.jpeg";
import img17 from "../assets/gallery/image17.jpeg";
import img18 from "../assets/gallery/image18.jpeg";
import img19 from "../assets/gallery/image19.jpeg";
import img20 from "../assets/gallery/image20.jpeg";
import img21 from "../assets/gallery/image21.jpeg";

export const staticGalleryImages = [
  { id: "static-1", src: img1 },
  { id: "static-2", src: img2 },
  { id: "static-3", src: img3 },
  { id: "static-4", src: img4 },
  { id: "static-5", src: img5 },
  { id: "static-6", src: img6 },
  { id: "static-7", src: img7 },
  { id: "static-8", src: img8 },
  { id: "static-9", src: img9 },
  { id: "static-10", src: img10 },
  { id: "static-11", src: img11 },
  { id: "static-12", src: img12 },
  { id: "static-13", src: img13 },
  { id: "static-14", src: img14 },
  { id: "static-15", src: img15 },
  { id: "static-16", src: img16 },
  { id: "static-17", src: img17 },
  { id: "static-18", src: img18 },
  { id: "static-19", src: img19 },
  { id: "static-20", src: img20 },
  { id: "static-21", src: img21 },
];
